import * as React from 'react';
import { Route, Switch } from 'react-router';
import loadable from '@loadable/component';
import { ValuationContextProvider } from '../../../../utils/context/ValuationContext';
import { InflationContextProvider } from '../../../../utils/context/InflationContext';
import { PageLoaderFallback } from '../../../layout/PageLoaderFallback';

const MidtsideOgFosen = loadable(
  () => import(/* webpackPrefetch: true */ './Midtsiden')
);

const ValuationKampanje = loadable(
  () => import(/* webpackPrefetch: true */ './Verdivurdering')
);
const Main = loadable(() => import(/* webpackPrefetch: true */ './Main'));

const Article = loadable(() => import(/* webpackPrefetch: true */ './Article'));
const VikoyrFotoInterior = loadable(
  () => import(/* webpackPrefetch: true */ '../vikoyr/VikoyrFotoInterior'),
  {
    fallback: <PageLoaderFallback />
  }
);

const NoMatch = loadable(
  () => import(/* webpackPrefetch: true */ '../../404Old')
);

const VikoyrIndex: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/kampanje/vikoyr/kjop" component={MidtsideOgFosen} />
      <Route
        exact
        path="/kampanje/vikoyr/verdivurdering"
        component={ValuationKampanje}
      />

      <Route exact path="/kampanje/vikoyr/" component={ValuationKampanje} />

      <Route
        exact
        path="/kampanje/:urltag(vikoyr)/main"
        render={(props) => (
          <InflationContextProvider {...props}>
            <ValuationContextProvider {...props}>
              <Main {...props} />
            </ValuationContextProvider>
          </InflationContextProvider>
        )}
      />

      <Route
        exact
        path="/kampanje/:urltag(vikoyr)/main/:slug"
        render={(props) => {
          return (
            <InflationContextProvider {...props}>
              <Article />
            </InflationContextProvider>
          );
        }}
      />
      <Route
        exact
        path="/kampanje/vikoyr/gratis-foto-interiorveiledning"
        component={VikoyrFotoInterior}
      />

      <Route component={NoMatch} />
    </Switch>
  );
};

export default VikoyrIndex;
